/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { auth } from '../_actions/user_actions';
import { useSelector, useDispatch } from 'react-redux';

export default function (SpecificComponent, option, adminRoute = null) {
  function AuthenticationCheck(props) {
    let user = useSelector((state) => state.user);
    const dispatch = useDispatch();
    const [isAuthorized, setIsAuthorized] = useState(false);

    useEffect(() => {
      //To know my current status, send Auth request
      dispatch(auth()).then((response) => {
        //Not Loggined in Status
        if (!response.payload.isAuth) {
          if (option) {
            props.history.push('/login');
          } else {
            setIsAuthorized(true);
          }
          //Loggined in Status
        } else {
          // Logged in Status, but Try to go into log in page
          if (option === false) {
            props.history.push('/');
            return;
          }
          // Role-based access control: adminRoute 配列に含まれない role はトップへ
          if (adminRoute !== null && !adminRoute.includes(response.payload.role)) {
            props.history.push('/');
            return;
          }
          //supposed to be Admin page, but not admin person wants to go inside
          if (!response.payload.changePassword) {
            // console.log('here');
            // props.history.push('/cp');
          }
          setIsAuthorized(true);
        }
      });
    }, []);

    if (!isAuthorized) return null;

    return <SpecificComponent {...props} user={user} />;
  }
  return AuthenticationCheck;
}
